export const appConfig = {
  name: 'Online Doctor Appointment',
  shortName: 'ODA',
  version: '0.1.0',
  defaultApiBaseUrl: 'http://localhost:8000/api/v1',
  storageKeys: {
    theme: 'onlineDoctor.theme',
    primary: 'onlineDoctor.primary',
    sidebarMini: 'onlineDoctor.sidebarMini',
  },
} as const
